import { VStack } from "@chakra-ui/react"
import React from "react"
import { CreatePermissionsGroupForm } from "../../forms"

export const CreatePermissionsGroup: React.FC = () => {
	return (
		<VStack w="full" maxW="sm" spacing={6}>
			<CreatePermissionsGroupForm />
		</VStack>
	)
}
